import { mode } from "@chakra-ui/theme-tools";

export const globalStyles = {
	colors: {
		gray: {
			700: "#33333B",
		},
	},
	styles: {
		global: (props) => ({
			body: {
				bg: mode("gray.50", "#282830")(props),
				fontFamily: "'Poppins', sans-serif",
			},
			html: {
				fontFamily: "'Poppins', sans-serif",
			},
		}),
	},
};
